import React, { useState } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useParams,
  Link,
} from "react-router-dom";
// import logo from "../../assets/images/logo.png";
// import startpng from "../../assets/images/star.png";
// import banner from "../../assets/images/banner.png";
// import Membership from "../small components/Membership";
// import Testimonials from "../small components/Testimonials";
import Footer from "../small components/Footer";
import SignUpform from "../small components/SignUpform";
import Loginform from "../small components/Loginform";
import yellow_Png from "../../assets/images/yellowball.png";
import blue_Png from "../../assets/images/blueball.png";
import Header from "./components/Header";
import ScrollAnimation from "react-animate-on-scroll";

function Signup(props) {
  const [toggle, setToggle] = useState(true);
  return (
    <React.Fragment>
      <div className="container-fluid main-bg">
        <div className="main">
          <Header />
          <ScrollAnimation
            delay={500}
            animateIn="animate__fadeIn"
            animateOnce={true}
          >
            <div className="row mx-auto py-2 mb-lg-5">
              <div className="col-md-9 m-auto py-2">
                <div className="br-15 bg-white shade hover-shade px-md-5">
                  <img
                    className="position-absolute yellow-ball d-md-block d-none"
                    src={yellow_Png}
                    alt="yellow_ball"
                  />
                  <img
                    className="position-absolute blue-ball d-md-block d-none"
                    src={blue_Png}
                    alt="blue_ball"
                  />
                  <img
                    className="position-absolute small-blue-ball d-md-block d-none"
                    src={blue_Png}
                    alt="smallblue_ball"
                  />
                  <Loginform />
                </div>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default Signup;
